module.exports = __webpack_public_path__ + "media/images/logo-white-e2ad0865a5a71f162c67ef029031c3b8.png";